export const LOCK_TYPES = {
  NONE: "None",
  DATE: "Date",
  TIME: "Time",
  USER: "User",
};

export const DUMMY_PASSWORD = "00000000";
